/* eslint-disable */
export default {
  topic: '会议标题',
} as const;

// @key: @#@"topic"@#@ @source: @#@"Meeting title"@#@
